import React from 'react'

export default class SubmitButton extends React.Component {
  static get defaultProps () {
    return {
      text: 'Submit'
    }
  }

  render () {
    return (
      <button
        type='submit'
        className='w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition duration-150 ease-in-out'
      >
        {this.props.text}
      </button>
    )
  }
}
